export default __webpack_public_path__ + "static/media/cat3.29ad4658.gif";